import { createSlice } from '@reduxjs/toolkit';

export type NotificationCampaign = {
  campaign_id: number;
  rotation_paused: number;
  is_carousel: number;
  contexts: string[];
  messages: any[];
};

type NotificationsState = {
  campaigns: NotificationCampaign[];
};

const initialState: NotificationsState = {
  campaigns: []
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    updateScrollingNotifications: (state, action) => {
      state.campaigns = action.payload || [];
    }
  }
});

export const { updateScrollingNotifications } = notificationsSlice.actions;

export default notificationsSlice.reducer;
